import QuickRatioComponent from 'components/calwidget/quick-ratio'
import CurrentRatioComponent from 'components/calwidget/current-ratio'
import PeRatioComponent from 'components/calwidget/pe-ratio'
import GrossProfitRatioComponent from './gross-profit-ratio'

export default {
  'current-ratio-formula': CurrentRatioComponent,
  'quick-ratio-formula': QuickRatioComponent,
  'pe-ratio-formula-price-to-earnings': PeRatioComponent,
  'gross-profit-ratio-meaning-formula-interpretation':
    GrossProfitRatioComponent,
}
